var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"header",attrs:{"slot":"header"},slot:"header"},[_c('img',{staticStyle:{"margin-left":"2px"},attrs:{"src":require("../image/schedule.png")}}),_c('span',[_c('strong',[_vm._v("Schedule")])])]),_c('ScheduleForm',{attrs:{"population":_vm.population}}),_c('ScheduleTable',{attrs:{"schedule":_vm.schedule}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }